import { authHeader } from '../util/authHeader'
import { userService } from './auth-api.service'

let baseUrl = process.env.VUE_APP_API_BASE_URL

export const formService = {
  getInProgress,
  getInProgressSingle,
  getPolicyDetails,
  deleteInProgressSingle,
  getHandoverDetails
}

function getInProgress (params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  if (params) {
    var query = Object.keys(params)
      .map(k => escape(k) + '=' + escape(params[k]))
      .join('&')
  }

  return fetch(baseUrl + `/api/v1/onlineclaim/standalone/partial/inprogress/` + '?' + query, requestOptions).then(handleResponse)
}

function getInProgressSingle (params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(baseUrl + `/api/v1/onlineclaim/standalone/partial/` + params, requestOptions).then(handleResponse)
}

function deleteInProgressSingle (params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(baseUrl + `/api/v1/onlineclaim/standalone/partial/delete/` + params, requestOptions).then(handleResponse)
}

function getPolicyDetails (params) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(params)
  }
  return fetch(baseUrl + `/api/v1/standalonepolicy/getpolicy`, requestOptions).then(handleResponse)
}

function getHandoverDetails (params) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  }
  return fetch(baseUrl + `/api/v1/standalonehandover/load/` + params, requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        userService.logout()
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }

    return data
  })
}
